import React, {useEffect, useState} from 'react'
import {fetchPeopleCourses} from "../../../../redux/actions";
import {Button, Icon, Popup, Table} from "semantic-ui-react";
import moment from 'moment';
import {TrackingForm} from "./TrackingForm";

const token = sessionStorage.getItem('Token')

const DrawItem = (item, setTracking) => {
    return (
        <Table.Row key={`row-${item.id}`}>
            <Table.Cell textAlign={"right"}>{item.id}</Table.Cell>
            <Table.Cell>
                <small style={{fontWeight: 'bold'}}>{item.product ? 'Produto' : 'Curso'}</small>
                <br/>
                {item.course.name}
            </Table.Cell>
            <Table.Cell>
                <Popup
                    wide
                    on={'click'}
                    header={false}
                    content={() => {
                        return (<div>
                            <strong>Tipo de Frete:</strong> {item.freight_type_text} <br />
                            <strong>Endereço:</strong> {item.formatted_address}
                        </div>);
                    }}
                    trigger={<div style={{cursor: 'pointer'}}>{item.people.name}</div>}
                />
            </Table.Cell>
            <Table.Cell textAlign={"right"}>
                <Popup
                    wide
                    on={'click'}
                    header={false}
                    content={() => {
                        return (<div style={{minWidth: 200}}>
                            <pre>
                                Quantidade.: {item.quantity}<br />
                                Valor......: R$ {item.amount}<br />
                                Sub-total..: R$ {(item.quantity * item.amount).toFixed(2)}<br />
                                Frete......: R$ {item.freight}<br />
                                Valor total: R$ {item.total}<br />
                            </pre>
                        </div>);
                    }}
                    trigger={<div style={{cursor: 'pointer'}}>{item.total}</div>}
                />
            </Table.Cell>
            <Table.Cell textAlign={"center"}>{moment(item.created_at).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
            <Table.Cell>{item.course.free ? 'Grátis' : item.status_text}</Table.Cell>
            <Table.Cell>
                <Button
                    icon
                    size={"tiny"}
                    onClick={() => setTracking(item)}
                    title={item.rastreio ? "Já enviado" : "Informar envio"}
                    color={item.rastreio ? "green" : "red"}
                ><Icon name='world' /></Button>
            </Table.Cell>
        </Table.Row>
    );
}

export const Orders = () => {

    const [loading, setLoading] = useState(false);
    const [showTracking, setShowTracking] = useState(false);
    const [items, setItems] = useState([]);
    const [item, setItem] = useState({});

    const setTracking = (row) => {
        setItem(row);
        setShowTracking(true);
    }

    const fetchData = async () => {
        setShowTracking(false);
        setLoading(true);

        try {
            const res = await fetchPeopleCourses({active: 1, withPeople: 1, sort: 'created_at', direction: 'desc'});

            setItems(res.data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        async function getData() {
            await fetchData();
        }

        // noinspection JSIgnoredPromiseFromCall
        getData();
    }, [token]);


    return (
        <React.Fragment>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={2} textAlign={"center"}>Código</Table.HeaderCell>
                        <Table.HeaderCell>Descrição</Table.HeaderCell>
                        <Table.HeaderCell>Pessoa</Table.HeaderCell>
                        <Table.HeaderCell width={2} textAlign={"center"}>Valor</Table.HeaderCell>
                        <Table.HeaderCell width={2} textAlign={"center"}>Data</Table.HeaderCell>
                        <Table.HeaderCell width={2} textAlign={"center"}>Situação</Table.HeaderCell>
                        <Table.HeaderCell width={1}/>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        items.map((item) => DrawItem(item, setTracking))
                    }
                </Table.Body>
            </Table>
            <TrackingForm
                show={showTracking}
                item={item}
                onCancel={() => setShowTracking(false)}
                onSuccess={() => fetchData()}
            />
        </React.Fragment>
    )
}